<template>
	<div>
		<div class="mianBox">
			<img src="../../assets/images/yun0.png" alt="" class="yun yun0" />
			<img src="../../assets/images/yun1.png" alt="" class="yun yun1" />
			<img src="../../assets/images/yun2.png" alt="" class="yun yun2" />
			<img src="../../assets/images/bird.png" alt="" class="bird" />
			<img src="../../assets/images/san.png" alt="" class="san" />
			<div class="tipInfo">
				<div class="in">
					<div class="textThis">
						<h2>出错啦404！</h2>
						<el-button type="success" style="display: block;text-align: right;" @click="goBack()">返回</el-button>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			}
		}

	}
</script>

<style>
	.tipInfo {
		position: absolute;
		top:15%;
		right: 55%;
		z-index: 99;
		margin-left: 150px;
		border: 4px solid #c0ece7;
		border-color: rgba(192, 237, 232, 07);
		border-radius: 5px;
		derbackground: #c0ece7;
		background: rgba(192, 237, 232, 07);
		width: 360px
	}
	
	.tipInfo .in {
		background: #fff;
		padding: 0 10%
	}
	
	.tipInfo .in h2 {
		line-height: 50px;
		font-size: 30px;
		color: #e94c3c;
		border-bottom: 1px dashed #aacdd5;
		padding: 18px 0
	}
	
	.tipInfo .in p {
		padding: 30px 0 50px 0;
		text-align: center;
		color: #289575
	}
	
	.tipInfo .in p span {
		margin: 0 20px
	}
	
	.tipInfo .in p span a {
		color: #e94c3c;
		margin: 0 10px
	}
	
	.tipInfo .in .desc {
		overflow: hidden;
		font-size: 14px;
		color: #2b2b2b;
		padding: 0 10%
	}
	
	.tipInfo .in .desc h3 {
		font-weight: normal;
		padding: 20px 0 5px 0
	}
	
	.tipInfo .in .desc li {
		/*		background: url("../images/404/dot.png") no-repeat left center;*/
		margin-left: 5px;
		padding: 5px 0;
		padding-left: 8px;
		*padding-left: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/system/404.vue